document.addEventListener("DOMContentLoaded", function () {
  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  addToCartForms.forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      });

      const res = await fetch("/cart.json");
      const cart = await res.json();

      document.querySelectorAll(".cart-count").forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.add("items");
      });

      const addBtn = form.querySelector(".add-to-cart-btn");
      addBtn.textContent = "Sepete Eklendi";
      addBtn.classList.add("added-to-cart");
      addBtn.classList.add("disabled");
    });
  });
});
